import { EnvironmentConfigSymbol } from './config';
import type { Env, Partition } from './envConsts';

export function setEnv(env: Env) {
  window[EnvironmentConfigSymbol] = {
    ...window[EnvironmentConfigSymbol],
    env,
  };
}

export function setRegion(region: string) {
  window[EnvironmentConfigSymbol] = {
    ...window[EnvironmentConfigSymbol],
    region,
  };
}

export function setPartition(partition: Partition) {
  window[EnvironmentConfigSymbol] = {
    ...window[EnvironmentConfigSymbol],
    partition,
  };
}

export function clearEnv() {
  if (window[EnvironmentConfigSymbol]) {
    delete window[EnvironmentConfigSymbol].env;
  }
}

export function clearRegion() {
  if (window[EnvironmentConfigSymbol]) {
    delete window[EnvironmentConfigSymbol].region;
  }
}

export function clearPartition() {
  if (window[EnvironmentConfigSymbol]) {
    delete window[EnvironmentConfigSymbol].partition;
  }
}
